import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IPatient } from '../types/interfaces/IPatient';

export async function getPatients(): Promise<ApiResponse<IPatient[]>> {
  return apiClient.get<IPatient[]>('/patients');
}

export async function getPatientById(id: string): Promise<ApiResponse<IPatient>> {
  return apiClient.get<IPatient>(`/patients/${id}`);
}

export async function createPatient(
  data: Omit<IPatient, 'id'>
): Promise<ApiResponse<IPatient>> {
  return apiClient.post<IPatient>('/patients', data);
}

export async function updatePatient(
  id: string,
  data: Partial<IPatient>
): Promise<ApiResponse<IPatient>> {
  return apiClient.put<IPatient>(`/patients/${id}`, data);
}

export async function deletePatient(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/patients/${id}`);
}
